/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialCompanyResponse } from '../../models/editorial-company-response';

export interface GetEditorialCompanyByInvitationCode$Params {
  invitationCode: string;
}

export function getEditorialCompanyByInvitationCode(http: HttpClient, rootUrl: string, params: GetEditorialCompanyByInvitationCode$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCompanyResponse>> {
  const rb = new RequestBuilder(rootUrl, getEditorialCompanyByInvitationCode.PATH, 'get');
  if (params) {
    rb.path('invitationCode', params.invitationCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialCompanyResponse>;
    })
  );
}

getEditorialCompanyByInvitationCode.PATH = '/api/editorial/companies/invitationCode/{invitationCode}';
